export {
  FlightSummaryTitle,
  FlightSummarySubTitle,
  FlightSummaryInlineTitle,
} from './FlightSummaryTitle';
